/*eslint-disable */
define(function (require) {
  "use strict";

  var Backbone = require("backbone");
  var Mustache = require("mustache");
  var gt = require("common/analytics/google-tagmanager");
  var _ = require("underscore");
  var $ = require("jquery");
  var config = require("common/page-config");
  var events = require("common/event-aggregator");

  var EmployeeSelectionCollection = require("./employee-selection-collection");

  var EmployeeSelectionView = Backbone.View.extend({
    collection: new EmployeeSelectionCollection(),

    config: config,

    ui: {},

    employeeTemplateId: "date-time-page-employee-tmpl",
    popupEmployeeTemplateId: "date-time-page-popup-employee-template",

    events: {
      "click .employee-selected": "toggleEmployees",
    },

    initialize: function (options) {
      if (options) {
        this.options = options;
      }

      // update collection
      this.collection.reset(this.options.employees);
      this.options.track.init(this.collection.models.length);

      //make sure review score is to 1 dp
      this.collection.forEach(function (model) {
        const treatmentReviewScore = model.get("treatmentReviewScore");

        if (treatmentReviewScore) {
          let reviewScoreToOneDecimalPlace = Number(
            treatmentReviewScore
          ).toFixed(1);
          model.set({ treatmentReviewScore: reviewScoreToOneDecimalPlace });
        }
      });

      this.employeeCount = this.collection.models.length;

      // add 'default' selection: 'Any employee' to the collection
      if (this.collection.models.length > 0) {
        if (this.collection.models.length > 1) {
          this.collection.add(
            {
              id: "any",
              employeeId: "any",
              employeeName: this.config.cms.bookingCms["any-employee-label"],
              photoUri: this.config.cms.anyEmployeeIcon,
              // select first employee options if none is passed on the options
            },
            { at: 0 }
          );
        }

        if (!this.options.employeeSelected) {
          this.options.employeeSelected = this.collection.at(0).id;
        } else {
          this.listenTo(
            events,
            events.CHECKOUT_AVAILABILITY_EMPLOYEE_NOT_AVAILABLE,
            this.resetSelectedEmployee
          );
          this.listenTo(
            events,
            events.CHECKOUT_AVAILABILITY_PAGE_LOADED,
            this.stopListeningToEmployeeUnavailable
          );
        }
      }

      // initialize UI
      this.ui.employeeSelected = this.$el.find(".employee-selected");
      this.ui.employeeLabel = this.$el.parent().find(".select-employee");

      // if collection has more than one model add event to expand the dropdown
      if (this.collection.models.length === 1) {
        this.$el.addClass("single");
      }
    },

    setEmployees: function (employees) {
      this.options.employees = employees;
      this.initialize();
    },

    render: function () {
      var selectedEmployee;

      if (this.collection.length > 0) {
        this.renderSelected();

        this.$el.css({
          height: "auto",
        });

        // check if employees will be shown on a dropdown or popup
        if (this.options.employeesPopup) {
          this.renderPopup();
        } else {
          this.renderDropdown();
        }

        this.ui.employeeSelected.show();
        this.ui.employeeLabel.show();

        // attach event for the click employee selection
        $(".employee-list > .employee").on(
          "click",
          _.bind(this.onEmployeeSelected, this)
        );
      } else {
        this.$el.css({
          height: 0,
        });
        this.ui.employeeSelected.hide();
        this.ui.employeeLabel.hide();
      }

      // trigger initial employee selection, if different from null or any
      selectedEmployee = $(".employee-selected .employee").data("id");

      if (selectedEmployee && selectedEmployee !== "any") {
        events.trigger(
          events.CHECKOUT_AVAILABILITY_EMPLOYEE_SELECTED,
          this.collection.get(selectedEmployee)
        );
      }
    },

    resetSelectedEmployee: function () {
      var employeeId = this.collection.at(0).id;

      this.options.employeeSelected = employeeId;
      this.renderSelected();

      // fire event checkout-availability:EmployeeSelected with employee model
      events.trigger(
        events.CHECKOUT_AVAILABILITY_EMPLOYEE_SELECTED,
        employeeId === "any" ? [] : this.collection.get(employeeId)
      );
    },

    stopListeningToEmployeeUnavailable: function () {
      this.stopListening(
        events,
        events.CHECKOUT_AVAILABILITY_EMPLOYEE_NOT_AVAILABLE,
        this.resetSelectedEmployee
      );
      this.stopListening(
        events,
        events.CHECKOUT_AVAILABILITY_PAGE_LOADED,
        this.stopListeningToEmployeeUnavailable
      );
    },

    renderSelected: function () {
      var template = $("#" + this.employeeTemplateId).html(),
        templateDate = this.collection.get(this.options.employeeSelected);

      // if selected employee is not available anymore, select the first available one
      if (!templateDate) {
        templateDate = this.collection.get(this.collection.at(0).id);
      }

      this.ui.employeeSelected.html(
        Mustache.render(template, templateDate.toJSON())
      );
    },

    renderDropdown: function () {
      var template = $("#" + this.employeeTemplateId).html();

      // set the ui element
      this.ui.employeeList = this.$el.find(".employee-list");
      // clear previous employees
      this.ui.employeeList.empty();

      this.collection.each(function (employee) {
        this.ui.employeeList.append(
          Mustache.render(template, employee.toJSON())
        );
      }, this);
    },

    renderPopup: function () {
      var employeesList,
        template = $("#" + this.popupEmployeeTemplateId).html();

      // set the ui element
      this.ui.employeePopup = $("#date-time-page-employee-select");
      this.ui.employeePopup.on("popupafterclose", () =>
        this.options.track.close(this.employeeCount)
      );
      this.ui.employeeList = this.ui.employeePopup.find(".employee-list");
      // clear previous employees list
      this.ui.employeeList.empty();
      // render each employee
      this.collection.each(function (employee) {
        const employeeData = {
          id: employee.get("employeeId"),
          photo: employee.get("photoUri"),
          name: employee.get("employeeName"),
          treatmentReviewScore: employee.get("treatmentReviewScore"),
          selected:
            this.options.employeeSelected === employee.get("employeeId"),
          isAny: isNaN(employee.get("id")),
        };

        this.ui.employeeList.append(Mustache.render(template, employeeData));
      }, this);
    },

    toggleEmployees: function () {
      this.options.employeesPopup ? "togglePopup" : "toggleDropdown";

      if (this.options.employeesPopup) {
        this.togglePopup();
      } else {
        this.toggleDropdown();
      }
    },

    toggleDropdown: function () {
      if (this.options.dropdown) {
        this.options.track.close(this.employeeCount);
        this.ui.employeeList.hide();
        this.ui.employeeSelected.removeClass("expanded");
        this.$el.removeClass("expanded");
        this.options.dropdown = false;
        return false;
      }
      this.options.track.open(this.employeeCount);
      this.ui.employeeList.show();
      this.ui.employeeSelected.addClass("expanded");
      this.$el.addClass("expanded");
      this.options.dropdown = true;
    },

    togglePopup: function () {
      if (this.ui.employeePopup.parent().hasClass("ui-popup-active")) {
        this.ui.employeePopup.popup("close");
        return;
      }
      this.options.track.open(this.employeeCount);
      this.ui.employeePopup.popup("open");
    },

    selectEmployee: function (employeeID) {
      // set the selected employee
      this.options.employeeSelected = employeeID;
      // update selected employee node
      this.renderSelected();

      // Show employee selected in popup employee list.
      var selectedEmployeeNode = this.ui.employeeList.find(
        '[data-id="' + employeeID + '"]'
      );
      selectedEmployeeNode.addClass("on").siblings().removeClass("on");

      // fire event checkout-availability:EmployeeSelected with employee model
      events.trigger(
        events.CHECKOUT_AVAILABILITY_EMPLOYEE_SELECTED,
        employeeID === "any" ? [] : this.collection.get(employeeID)
      );
    },

    onEmployeeSelected: function (event) {
      var selectedIndex =
        this.employeeCount === 1
          ? 1 // there's no 'any employee' in the list
          : Array.from(event.currentTarget.parentNode.children).indexOf(
            event.currentTarget
          );
      var selectedEmployeeNode,
        employeeID = $(event.currentTarget).data("id");
      this.options.track.select(employeeID, selectedIndex, this.employeeCount);

      // set the selected employee
      this.options.employeeSelected = employeeID;
      // update selected employee node
      this.renderSelected();
      // update employee list
      selectedEmployeeNode = this.ui.employeeList.find(
        '[data-id="' + employeeID + '"]'
      );
      selectedEmployeeNode.addClass("on").siblings().removeClass("on");

      if (this.options.employeesPopup) {
        this.togglePopup();
      } else {
        this.toggleDropdown();
      }

      // fire event checkout-availability:EmployeeSelected with employee model
      events.trigger(
        events.CHECKOUT_AVAILABILITY_EMPLOYEE_SELECTED,
        employeeID === "any" ? [] : this.collection.get(employeeID)
      );
    },

    destroy: function () {
      $(".employee-list > .employee").off(
        "click",
        _.bind(this.onEmployeeSelected, this)
      );
      this.undelegateEvents();
    },
  });

  return EmployeeSelectionView;
});
